export default __webpack_public_path__ + "static/google_Desktop4-0c1b423e4492dfa41cd6f5873c207a6f.svg";